import React, { useEffect, useState, useCallback } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import image from '../../assets/images/icons/side-nav-logo.png';
import dashboardIcon from '../../assets/images/icons/dashboard-icon.svg';
import commuterIcon from '../../assets/images/icons/commuters-icon.svg';
import ageniciesIcon from '../../assets/images/icons/agencies-icon.svg';
import vendorIcon from '../../assets/images/icons/vendor-icon.svg';
import awardPointIcon from '../../assets/images/icons/awardpoint-icon.svg';
import settingIcon from '../../assets/images/icons/setting-icon.svg';
import redeemIcon from '../../assets/images/icons/redeem-icon.png';
import inActiveQRIcon from '../../assets/images/icons/inactive-qr-code.svg';
import activeQRIcon from '../../assets/images/icons/active-qr-code.svg';
import logoutIcon from '../../assets/images/icons/logout.png';
//Active Icons
import dashboardActive from '../../assets/images/active_icons/dashboard_active.png';
import commuterActive from '../../assets/images/active_icons/commuters_active.png';
import awardedActive from '../../assets/images/active_icons/awarded_active.png';
import settingActive from '../../assets/images/active_icons/settings_active.png';
import vendorActive from '../../assets/images/active_icons/vendor_active.png';
import agencyActive from '../../assets/images/active_icons/agency_active.png';
import redeemActive from '../../assets/images/active_icons/redeem_active.png';
import useWindowSize from '../../hooks/useWindowSize';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import hazardIcon from '../../assets/images/icons/alert-octagon.svg';
import usersIcon from '../../assets/images/icons/users-icon.svg';
import usersIconActive from '../../assets/images/active_icons/users-active-icon.svg';
import offersIcon from '../../assets/images/icons/offers.svg';
import offersActiveIcon from '../../assets/images/active_icons/offers-active.svg';
import menuItemsIcon from '../../assets/images/icons/menu-items.svg';
import menuItemsActiveIcon from '../../assets/images/active_icons/menu-items-active.svg';
import redemptionsIcon from '../../assets/images/icons/redemptions.svg';
import redemptionsActiveIcon from '../../assets/images/active_icons/redemptions-active.svg';
import stopsIcon from '../../assets/images/icons/stops.svg';
import stopsActiveIcon from '../../assets/images/active_icons/stops-active.svg';
import routeIcon from '../../assets/images/icons/routes.svg';
import routeActiveIcon from '../../assets/images/active_icons/routes-active.svg';
import tripsIcon from '../../assets/images/icons/trips.svg';
import tripsActiveIcon from '../../assets/images/active_icons/trips-active.svg';
import bookingsIcon from '../../assets/images/icons/bookings.svg';
import bookingsActiveIcon from '../../assets/images/active_icons/bookings-active.svg';
import demographicsIcon from '../../assets/images/icons/demographic.svg';
import demographicsActiveIcon from '../../assets/images/active_icons/demographics-active.svg';
import fareIcon from '../../assets/images/icons/fare-icon.svg';
import fareActiveIcon from '../../assets/images/active_icons/fare-active-icon.svg';
import cardIcon from '../../assets/images/icons/card.svg';
import cardActiveIcon from '../../assets/images/active_icons/card-active.svg';
import pinIcon from '../../assets/images/icons/pin-icon.svg';
import pinActiveIcon from '../../assets/images/active_icons/pin-active-icon.svg';
import rewardPoint from '../../assets/images/icons/reward-points.svg';
import rewardActivePoint from '../../assets/images/active_icons/reward-active-points.svg';
import rewardTier from '../../assets/images/icons/reward-tiers.svg';
import rewardActiveTier from '../../assets/images/active_icons/reward-active-tiers.svg';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
const Sidebar = (props) => {
    const [role, setRole] = useState('');
    const { logout, user, getToken } = useAuth();
    const { width } = useWindowSize();
    const [fareSettingsCheck, setFareSettingsCheck] = useState(false);
    const [stripeAccount, setStripeAccount] = useState({ payouts_enabled: true, details_submitted: true });
    const [locationPath, setCurrentLocationPath] = useState('');
    const [showRewardsSummary, setShowRewardsSummary] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const sidebarToggle = props.sidebarToggle;
    const sidebarHandler = props.sidebarHandler;
    const location = useLocation();
    let sidebarMenu = [
        {
            name: 'Dashboards',
            path: '/',
            icon: dashboardIcon,
            activeIcon: dashboardActive,
            role: 'agency',
            type: 'normal'
        },
        {
            name: 'Stops',
            path: '/stops',
            icon: stopsIcon,
            activeIcon: stopsActiveIcon,
            type: 'normal'
        },
        {
            name: 'Agencies',
            path: '/agencies',
            icon: ageniciesIcon,
            activeIcon: agencyActive,
            type: 'normal'
        },
        {
            name: 'Routes',
            path: '/routes',
            icon: routeIcon,
            activeIcon: routeActiveIcon,
            role: 'agency',
            type: 'normal'
        },
        {
            name: 'Trips',
            path: '/trips',
            icon: tripsIcon,
            activeIcon: tripsActiveIcon,
            role: 'agency',
            type: 'normal'
        },
        {
            name: 'Vendors',
            path: '/vendors',
            icon: vendorIcon,
            activeIcon: vendorActive,
            type: 'normal'
        },
        ...(user.role !== 'vendor'
            ? [
                  {
                      name: 'Bookings',
                      path: '/bookings',
                      icon: bookingsIcon,
                      activeIcon: bookingsActiveIcon,
                      type: 'normal',
                      role: 'agency'
                  }
              ]
            : []),
        {
            name: 'QR Codes',
            path: '/qr-codes',
            icon: inActiveQRIcon,
            activeIcon: activeQRIcon,
            type: 'normal'
        },
        {
            name: 'Commuters',
            path: '/commuters',
            icon: commuterIcon,
            activeIcon: commuterActive,
            role: 'agency',
            type: 'normal'
        },
        {
            name: 'Rewards Summary',
            icon: awardPointIcon,
            activeIcon: awardedActive,
            type: 'nested',
            childs: [
                {
                    name: 'Rewards Accrual',
                    path: '/rewards-accrual',
                    icon: awardPointIcon,
                    activeIcon: awardedActive
                },
                {
                    name: 'Rewards Redemption History',
                    path: '/rewards-redemption-history',
                    icon: redeemIcon,
                    activeIcon: redeemActive
                },
                {
                    name: 'Reward Points Setting',
                    path: '/reward-points-setting',
                    icon: rewardPoint,
                    activeIcon: rewardActivePoint
                },
                {
                    name: 'Reward Tiers',
                    path: '/demographics/reward-tiers',
                    icon: rewardTier,
                    activeIcon: rewardActiveTier
                }
            ],
            role: 'agency'
        },
        {
            name: 'Settings',
            path: '/settings',
            icon: usersIcon,
            activeIcon: usersIconActive,
            role: 'agency',
            type: 'normal'
        }
    ];
    if (user.role === 'agency') {
        sidebarMenu = [
            {
                name: 'Dashboards',
                path: '/',
                icon: dashboardIcon,
                activeIcon: dashboardActive,
                type: 'normal',
                role: 'agency'
            },
            {
                name: 'Trips',
                path: '/trips',
                icon: tripsIcon,
                activeIcon: tripsActiveIcon,
                type: 'normal',
                role: 'agency'
            },
            {
                name: 'Commuters',
                path: '/commuters',
                icon: commuterIcon,
                activeIcon: commuterActive,
                type: 'normal',
                role: 'agency'
            },
            {
                name: 'Routes',
                path: '/routes',
                icon: routeIcon,
                activeIcon: routeActiveIcon,
                type: 'normal',
                role: 'agency'
            },

            {
                name: 'Rewards Accrual',
                path: '/rewards-accrual',
                icon: awardPointIcon,
                activeIcon: awardedActive,
                type: 'normal',
                role: 'agency'
            },
            {
                name: 'Settings',
                icon: settingIcon,
                activeIcon: settingActive,
                hazardIcon: (!stripeAccount?.payouts_enabled && !stripeAccount?.details_submitted) || fareSettingsCheck ? hazardIcon : undefined,

                type: 'nested',
                childs: [
                    {
                        name: 'Account Settings',
                        path: '/settings',
                        icon: usersIcon,
                        activeIcon: usersIconActive,
                        role: 'agency',
                        type: 'normal'
                    },
                    {
                        name: 'Fare Settings',
                        path: '/fare-settings',
                        icon: fareIcon,
                        activeIcon: fareActiveIcon,
                        hazardIcon: fareSettingsCheck ? hazardIcon : undefined
                    },
                    {
                        name: 'Payment Settings',
                        path: '/payment-settings',
                        icon: cardIcon,
                        activeIcon: cardActiveIcon,
                        hazardIcon: stripeAccount?.payouts_enabled && stripeAccount?.details_submitted ? undefined : hazardIcon
                    }
                ]
            }
        ];
    }

    if (user.role === 'commuter') {
        sidebarMenu = [
            {
                name: 'Dashboards',
                path: '/',
                icon: dashboardIcon,
                activeIcon: dashboardActive,
                type: 'normal',
                role: 'commuter'
            },
            {
                name: 'Bookings',
                path: '/bookings',
                icon: bookingsIcon,
                activeIcon: bookingsActiveIcon,
                type: 'normal',
                role: 'agency'
            },

            {
                name: 'Trips',
                path: '/trips',
                icon: tripsIcon,
                activeIcon: tripsActiveIcon,
                type: 'normal',
                role: 'commuter'
            },
            {
                name: 'Rewards Summary',
                icon: awardPointIcon,
                activeIcon: awardedActive,
                type: 'nested',
                childs: [
                    {
                        name: 'Rewards Accrual',
                        path: '/rewards-accrual',
                        icon: awardPointIcon,
                        activeIcon: awardedActive,
                        role: 'commuter',
                        type: 'normal'
                    },
                    {
                        name: 'Redemptions',
                        path: '/redemptions',
                        icon: redeemIcon,
                        activeIcon: redeemActive,
                        role: 'commuter',
                        type: 'normal'
                    }
                ]
            },
            {
                name: 'Settings',
                icon: settingIcon,
                activeIcon: settingActive,
                type: 'nested',
                childs: [
                    {
                        name: 'Account Settings',
                        path: '/settings',
                        icon: usersIcon,
                        activeIcon: usersIconActive,
                        role: 'agency',
                        type: 'normal'
                    },
                    {
                        name: 'Freq. Used Locations',
                        path: '/frequently-used-locations',
                        icon: pinIcon,
                        activeIcon: pinActiveIcon,
                        role: 'commuter',
                        type: 'normal'
                    },
                    {
                        name: 'Demographics',
                        path: '/demographics-questions',
                        icon: demographicsIcon,
                        activeIcon: demographicsActiveIcon,
                        role: 'commuter',
                        type: 'normal'
                    }
                ]
            }
        ];
    }

    if (user.role === 'vendor') {
        sidebarMenu = [
            {
                name: 'Dashboards',
                path: '/',
                icon: dashboardIcon,
                activeIcon: dashboardActive,
                type: 'normal',
                role: 'vendor'
            },
            {
                name: 'Branches',
                path: '/branches',
                icon: ageniciesIcon,
                activeIcon: agencyActive,
                type: 'normal',
                role: 'vendor'
            },
            {
                name: 'Rewards',
                path: '/rewards',
                icon: offersIcon,
                activeIcon: offersActiveIcon,
                type: 'normal',
                role: 'vendor'
            },
            {
                name: 'Menu Items',
                path: '/menu-items',
                icon: menuItemsIcon,
                activeIcon: menuItemsActiveIcon,
                type: 'normal',
                role: 'vendor'
            },
            {
                name: 'Rewards Summary',
                icon: awardPointIcon,
                activeIcon: awardedActive,
                type: 'nested',
                childs: [
                    {
                        name: 'Redemptions',
                        path: '/redemptions',
                        icon: redemptionsIcon,
                        activeIcon: redemptionsActiveIcon
                    }
                ],
                role: 'vendor'
            },
            {
                name: 'Settings',
                path: '/settings',
                icon: usersIcon,
                activeIcon: usersIconActive,
                type: 'normal',
                role: 'vendor'
            }
        ];
    }

    sidebarMenu = [
        ...sidebarMenu,
        {
            name: 'Logout',
            icon: logoutIcon,
            activeIcon: logoutIcon,
            type: 'logout'
        }
    ];

    // Remove unused showSummary and setShowSummary

    useEffect(() => {
        try {
            if (user) {
                setRole(user.role);
            }
        } catch (error) {
            // handle error
        }
    }, [user]);

    // Fix useCallback dependencies
    const getTransitAgency = useCallback(() => {
        const token = getToken();
        if (token) {
            new WebApiCalls()
                .getSingleAgency(token, user?.transit_agency)
                .then((res) => {
                    if (res?.code === 200) {
                        if (res?.data?.bookings_config && Object.keys(res?.data?.bookings_config).length) {
                            Object.keys(res?.data?.bookings_config).some((key) => {
                                if (res?.data?.bookings_config[key]) {
                                    setFareSettingsCheck(false);
                                    return true;
                                } else {
                                    setFareSettingsCheck(true);
                                    return false;
                                }
                            });
                        } else {
                            setFareSettingsCheck(true);
                        }
                    }
                })
                .catch((err) => {});
        }
    }, [getToken, user?.transit_agency]);

    const getStripeAccount = useCallback(() => {
        const token = getToken();
        if (token)
            new WebApiCalls()
                .getStripeAccount(token)
                .then((res) => {
                    setStripeAccount(res?.account);
                })
                .catch((err) => {});
    }, [getToken]);

    // Fix useEffect dependencies and avoid complex expressions
    useEffect(() => {
        setCurrentLocationPath(location.pathname.split('/')[1]);
    }, [location]);

    useEffect(() => {
        if (user.role === 'agency') {
            getTransitAgency();
        }
    }, [getTransitAgency, user.role]);

    useEffect(() => {
        if (user.role === 'agency') {
            getStripeAccount();
        }
    }, [getStripeAccount, user.role, locationPath]);

    return (
        <>
            <div className={`sidebar shadow ${sidebarToggle && 'show'}`}>
                <div className="logo_brand mb-5 pb-2">
                    <Navbar.Brand as={Link} to="/">
                        <img src={image} alt="Omega PSI PHI Fraternity Inc" className="img-fluid mb-2 mt-3" width={150} height={150} />
                    </Navbar.Brand>

                    {/* <h4 className="text-white fw-bold">Bella Life</h4> */}
                </div>
                <Nav as="ul" className="flex-column sidebar-menu mt-5 pb-5 px-2">
                    {sidebarMenu.map((item, i) => {
                        const itemLocation = location.pathname.split('/')[1];
                        if (item.type === 'nested') {
                            // Determine which toggle state to use
                            let showSubmenu = false;
                            let toggleSubmenu = null;
                            if (item.name === 'Rewards Summary') {
                                showSubmenu = showRewardsSummary;
                                toggleSubmenu = () => setShowRewardsSummary(!showRewardsSummary);
                            } else if (item.name === 'Settings') {
                                showSubmenu = showSettings;
                                toggleSubmenu = () => setShowSettings(!showSettings);
                            }
                            return (
                                <Nav.Item as="li" key={i} className="mb-2">
                                    <Nav.Item onClick={toggleSubmenu} className={'text-start mb-2'}>
                                        <img
                                            width={45}
                                            className={`img-fluid ps-2 pe-3${item.icon === item.activeIcon ? (showSubmenu ? ' active' : '') : ''}`}
                                            src={item.icon}
                                            alt=""
                                        />
                                        {item.name}
                                        <FontAwesomeIcon className={`ml-20 top-5 submenu-icon ${showSubmenu ? 'menu-open' : ''}`} icon={faAngleRight} />
                                        {item?.hazardIcon && (
                                            <span>
                                                <img width={40} className="img-fluid ps-2 pe-3" src={item?.hazardIcon} alt="" />
                                            </span>
                                        )}
                                    </Nav.Item>
                                    {item.childs.map((subItem, index) => {
                                        let routeLocation = subItem.path.split('/');
                                        routeLocation = routeLocation.length > 1 ? routeLocation[1] : subItem.path;
                                        const isActive = itemLocation === routeLocation;
                                        const useActiveClass = subItem.icon === subItem.activeIcon;
                                        return (
                                            <Nav.Link
                                                as={Link}
                                                key={index}
                                                to={subItem.path}
                                                onClick={() => width < 991.98 && sidebarHandler()}
                                                className={`mb-2 ${isActive ? 'text-start active' : 'text-start'} submenu ${showSubmenu ? 'show-submenu' : ''}`}
                                            >
                                                <span>
                                                    <img
                                                        width={45}
                                                        className={`img-fluid ps-2 pe-3${useActiveClass && isActive ? ' active' : ''}`}
                                                        src={isActive && !useActiveClass ? subItem?.activeIcon : subItem?.icon}
                                                        alt=""
                                                    />
                                                </span>
                                                {subItem.name}
                                                {subItem?.hazardIcon && (
                                                    <span>
                                                        <img width={40} className="img-fluid ps-2 pe-3" src={subItem?.hazardIcon} alt="" />
                                                    </span>
                                                )}
                                            </Nav.Link>
                                        );
                                    })}
                                </Nav.Item>
                            );
                        }
                        if (item.type === 'normal') {
                            let routeLocation = item.path.split('/');
                            routeLocation = routeLocation.length > 1 ? routeLocation[1] : item.path;
                            const isActive = itemLocation === routeLocation;
                            const useActiveClass = item.icon === item.activeIcon;
                            return (
                                <Nav.Item as="li" key={i} className="mb-2">
                                    <Nav.Link
                                        as={Link}
                                        to={item.path}
                                        onClick={() => width < 991.98 && sidebarHandler()}
                                        className={isActive ? 'text-start active' : 'text-start'}
                                    >
                                        <span>
                                            <img
                                                width={45}
                                                className={`img-fluid ps-2 pe-3${useActiveClass && isActive ? ' active' : ''}`}
                                                src={isActive && !useActiveClass ? item?.activeIcon : item?.icon}
                                                alt=""
                                            />
                                        </span>
                                        {item.name}
                                    </Nav.Link>
                                </Nav.Item>
                            );
                        }
                        if (item.type === 'logout') {
                            return (
                                <Nav.Item as="li" key={i} className="mb-2">
                                    <Nav.Link onClick={logout} className="text-start" style={{ cursor: 'pointer' }}>
                                        <span>
                                            <img width={45} className="img-fluid ps-2 pe-3" src={item.icon} alt="" />
                                        </span>
                                        {item.name}
                                    </Nav.Link>
                                </Nav.Item>
                            );
                        }
                        return null;
                    })}
                </Nav>
            </div>
        </>
    );
};
export default Sidebar;
